import Vue from 'vue';

// Domain
import { LinkGoalsWealthStateManager } from '../../domain/state/link-goals-wealth-state-manager';
import LinkGoalState from '../../domain/state/link-goals-state';
import Injectable from '@/modules/shared/domain/di/injectable';
import Observer from '@/modules/shared/domain/observer/observer';

@Injectable()
export default class LinkGoalsVueStateManager implements LinkGoalsWealthStateManager {
  private _state: LinkGoalState = Vue.observable<LinkGoalState>(
    new LinkGoalState(),
  );

  private readonly observers: Observer[] = [];

  get state(): LinkGoalState {
    return this._state;
  }

  set state(value: LinkGoalState) {
    this._state = value;
  }

  patch(state: Partial<LinkGoalState>) {
    type Keys = keyof LinkGoalState;
    Object.entries(state).forEach(([key, value]) => {
      const accessor = key as Keys;

      if (value !== undefined) {
        // eslint-disable-next-line
        // @ts-ignore @typescript-eslint/ban-ts-ignore
        this.state[accessor] = value;
      }
    });
  }

  notifyAll(): void {
    this.observers.forEach((observer) => observer.notify());
  }

  register(observer: Observer): void {
    this.observers.push(observer);
  }
}
